<script setup lang="ts">
import { useDeleteAlert } from "@/api/alert-query";
import { mdiDelete } from "@mdi/js";
import { Button, confirm, Icon } from "@soft-db/ui";
import { useI18n } from "vue-i18n";

const props = defineProps({
	id: {
		type: String,
		required: true,
	},
});

const deleteAlert = useDeleteAlert();

const { t } = useI18n();

async function confirmDeleteAlert() {
	if (await confirm.delete(t("actions.deleteAlert"))) {
		await deleteAlert.mutateAsync(props.id);
	}
}
</script>

<template>
	<Button color="error" variant="soft" shape="square" @click="confirmDeleteAlert">
		<Icon :d="mdiDelete" />
	</Button>
</template>
